export enum RouterPath {
  Home = "/",
  Journey = "/journey",
  Projects = "/projects",
  ProjectDetail = "/projects/:id",
  Contact = "/contact",
}

export enum MenuType {
  Home = "About",
  Journey = "Journey",
  Projects = "Projects",
  Contact = "Contact",
}

export enum SkillsCategories {
  Mobile = "Mobile",
  Frontend = "Frontend",
  Backend = "Backend",
  Tools = "Tools",
}

export enum SkillsType {
  // Mobile
  Flutter = "Flutter",
  Android = "Android",
  iOS = "iOS",
  Kotlin = "Kotlin",
  Java = "Java",

  // FrontEnd
  React = "React",
  TypeScript = "TypeScript",
  TailwindCss = "TailwindCSS",
  Redux = "Redux",

  // BackEnd
  ExpressJs = "ExpressJS",
  NodeJs = "NodeJS",
  Redis = "Redis",

  // Tools
  Figma = "Figma",
  AzureDevOps = "Azure DevOps",
  Jira = "Jira",
  Git = "Git",
  Firebase = "Firebase",
  Postman = "Postman",
}

export enum MyLinks {
  Email = "justforworkandstuff@hotmail.com",
  Github = "https://github.com/justforworkandstuff",
  LinkedIn = "https://www.linkedin.com/in/vitti-ng-592a30310/",
  Medium = "https://medium.com/@feiimomoo/about",
}

export enum Theme {
  Light,
  Dark,
}